import { useState, useCallback } from "react";
import { getComments, postComment, deleteComment } from "../APIs/commentApi";

// ✅ Hook ke bahar move kiya — pure functions hain
const addReplyDeep = (replies, parentId, newComment) => {
  return replies.map((r) =>
    r.id === parentId
      ? { ...r, replies: [...(r.replies || []), newComment] }
      : { ...r, replies: addReplyDeep(r.replies || [], parentId, newComment) }
  );
};

const removeDeep = (list, id) =>
  list
    .filter((c) => c.id !== id)
    .map((c) => ({ ...c, replies: removeDeep(c.replies || [], id) }));

const useComment = (postId) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [posting, setPosting] = useState(false);
  const [text, setText] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const [error, setError] = useState(null);

  const fetchComments = useCallback(async () => {
    if (!postId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await getComments(postId);
      setComments(data);
    } catch (err) {
      setError("Could not load comments.");
    } finally {
      setLoading(false);
    }
  }, [postId]);

  const handlePost = useCallback(async () => {
    if (!text.trim() || posting) return;
    setPosting(true);
    setError(null);
    try {
      const newComment = await postComment(postId, text.trim(), replyTo?.id || null);

      if (replyTo) {
        setComments((prev) =>
          prev.map((c) =>
            c.id === replyTo.id
              ? { ...c, replies: [...(c.replies || []), newComment] }
              : { ...c, replies: addReplyDeep(c.replies || [], replyTo.id, newComment) }
          )
        );
      } else {
        setComments((prev) => [newComment, ...prev]);
      }

      setText("");
      setReplyTo(null);
    } catch (err) {
      setError("Could not post comment.");
    } finally {
      setPosting(false);
    }
  }, [postId, text, posting, replyTo]);

  const handleDelete = useCallback(
    async (commentId) => {
      const prev = comments;
      setComments((c) => removeDeep(c, commentId));
      try {
        await deleteComment(postId, commentId);
      } catch (err) {
        setComments(prev);
        setError("Could not delete comment.");
      }
    },
    [postId, comments]
  );

  return {
    comments, loading, posting, text, replyTo, error,
    setText, setReplyTo, fetchComments, handlePost, handleDelete,
  };
};

export default useComment;